import {
  LOAD_REPORT_ADDRESSES,
  LOAD_REPORT_DETAILS_PAGE,
  RESET_ORDER_HISTORY_LOAD_ERROR,
} from 'constants/ActionTypes';

export const resetOrderHistoryErrors = () => ({ type: RESET_ORDER_HISTORY_LOAD_ERROR });

export const loadReportAddresses = (orderId) => ({ type: LOAD_REPORT_ADDRESSES, orderId });

export const loadReportDetailsPage = (reportId) => ({ type: LOAD_REPORT_DETAILS_PAGE, reportId });
